import { render, staticRenderFns } from "./Scan.vue?vue&type=template&id=21dc6b1e&scoped=true&"
import script from "./Scan.vue?vue&type=script&lang=js&"
export * from "./Scan.vue?vue&type=script&lang=js&"
import style0 from "./Scan.vue?vue&type=style&index=0&id=21dc6b1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc6b1e",
  null
  
)

export default component.exports